
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forum/thread/[...thread]",
      function () {
        return require("private-next-pages/forum/thread/[...thread].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forum/thread/[...thread]"])
      });
    }
  